import gql from 'graphql-tag';

const GET_TASK_LIST = gql`
  query getTasks($listInfo: ListInfoInput!, $module: String) {
    getTasks(listInfo: $listInfo, module: $module) {
      tasks {
        taskOrder
        createdTime
        taskId
        displayId
        title
        description
        status
        priority
        estimatedTime
        scheduledStartDate
        dueDate
        overdue
        actualStartDate
        actualEndDate
        technician {
          userId
          name
          email
          firstName
          lastName
        }
        milestone {
          milestoneId
        }
        techGroup {
          name
          groupId
        }
        ticket {
          ticketId
          subject
          displayId
          loggedInUserAsFollower {
            ticketPermission
          }
        }
        module
        project {
          projectId
          title
          loggedInUserRole {
            roleId
          }
        }
        workItem {
          workId
          displayId
          subject
          module
          client {
            accountId
            name
          }
          site {
            name
            id
          }
        }
        ticketPermission
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_TICKET_TASKS = gql`
  query getTicketTasks($ticketId: ID!) {
    getTicketTasks(ticketId: $ticketId) {
      taskId
      taskStatus
      createdTime
      title
      ticket {
        ticketId
      }
      technician {
        userId
        firstName
        lastName
      }
    }
  }
`;

const GET_ALL_TEMPLATELIST = gql`
  query {
    getTaskTemplateList {
      taskTemplateId
      title
      description
      technician {
        firstName
        lastName
        name
        userId
      }
      techGroup {
        name
        groupId
      }
      estimatedTime
      scheduledStartDate
      dueDate
    }
  }
`;

const GET_TASK_TEMPLATE = gql`
  query getTaskTemplate($templateId: ID!) {
    getTaskTemplate(templateId: $templateId) {
      taskTemplateId
      title
      description
      technician {
        firstName
        lastName
        name
        userId
      }
      techGroup {
        name
        groupId
      }
      estimatedTime
    }
  }
`;

const GET_TASK_VIEW_COUNT = gql`
  query getTaskViewsCount($viewIds: [ID]) {
    getTaskViewsCount(viewIds: $viewIds) {
      viewId
      count
    }
  }
`;

export {
  GET_TASK_LIST,
  GET_ALL_TEMPLATELIST,
  GET_TICKET_TASKS,
  GET_TASK_TEMPLATE,
  GET_TASK_VIEW_COUNT
};
